export const MFA_ERROR_CODES = {
  OTP_REQUIRED: 'MFA_OTP_REQUIRED',
  SETUP_REQUIRED: 'MFA_SETUP_REQUIRED',
} as const;

export const MFA_TOKEN_CLAIMS = {
  REQUIRED: 'mfa_required',
  ENABLED: 'mfa_enabled',
} as const;

/** True when the API message indicates a bad OTP/MFA code (toast only — do not logout). */
export function isInvalidMfaTokenMessage(message: unknown): boolean {
  if (typeof message !== 'string' || !message) {
    return false;
  }
  const normalized = message.toLowerCase();
  return (
    normalized.includes('invalid mfa') ||
    normalized.includes('invalid otp') ||
    normalized.includes('invalid authenticator') ||
    normalized.includes('invalid verification') ||
    (normalized.includes('invalid') && normalized.includes('mfa token'))
  );
}
